// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3NyFm","alertIcon":"ConfirmModal_alertIcon__1zo23"};